import { PUBLICURL } from './index'
//导入
export function downloadUrl(r, t) {
  if (r == 1) { //导入用户
    return '/api/manage/member/import'
  } else if (r == 2) { //岗位
    return '/api/manage/member/job/import'
  } else if (r == 3) { //门店
    return '/api/manage/member/store/import'
  } else if (r == 4) { //区域
    return '/api/manage/member/region/import'
  } else if (r == 7) { //审核员
    return '/api/manage/selfChecking/examine/people/import'
  } else if (r == 9) { //系统管理员
    return '/api/manage/system/manage/import'
  }
}


//模板
export function template(r, t) {
  console.log(r, t);

  let p = PUBLICURL + 'template/'
  if (r == 1) { //用户
    return p + 'member/member.xlsx'
  } else if (r == 2) {//岗位
    return p + 'member/job.xlsx'
  } else if (r == 3) {//门店
    return p + 'member/store.xlsx'
  } else if (r == 4) {//区域
    return p + 'member/region.xlsx'
  } else if (r == 5) {
    if (t == 1) {
      return p + 'selfChecking/member.xlsx'
    } else {
      return p + 'selfChecking/stores.xlsx'
    }
  } else if (r == 7) {//审核员
    return p + 'SelfCheckingExamine/people.xlsx'
  } else if (r == 8) {//习题
    return p + 'training/topic.xlsx'
  } else if (r == 99) { //自己的url
    return p + t
  }
}


//导出
export function exportUrl(r) {
  let token = localStorage.getItem('token')
  if (r == 1) {//导出用户
    return PUBLICURL + 'api/manage/member/export?api_token=' + token
  }
}

export function downloadName(t, m) {
  let n = ''
  if (t == 1) {
    n = '用户'
  } else if (t == 2) {
    n = '岗位'
  } else if (t == 3) {
    n = '门店'
  } else if (t == 4) {
    n = '区域'
  } else if (t == 5) {
    n = m == 1 ? '用户' : '门店'
  } else if (t == 6) {
    n = '分配'
  } else if (t == 7) {
    n = '审核员'
  } else if (t == 8) {
    n = '习题'
  } else if (t == 9) { //系统管理员
    n = '系统管理员'
  } else if (t == 10) { 
    n = '自检问卷'
  }
  return n + '模板'
}
